/**
 * 진행 상태 상수 및 유틸리티
 * 서버의 ProcessStatus enum과 일치하도록 정의
 *
 * 서버 enum 참조: com.metarpas.solvit.data.types.ProcessStatus
 * - BEF("BEF", "Before Processing")
 * - ING("ING", "Processing")
 * - FIN("FIN", "Finish")
 * - FLR("FLR", "Failure")
 * - UNK("UNK", "Unknown")
 * - CNL("CNL", "Cancelled")
 *
 * 표시 문구는 vue-i18n `progressStatus.{코드}` (ko.json / en.json)에서 관리합니다.
 */
import i18n from '@/plugins/i18n';

export const PROGRESS_STATUS = Object.freeze({
  BEF: 'BEF', // Before Processing - 분석전
  ING: 'ING', // Processing - 분석중
  FIN: 'FIN', // Finish - 분석완료
  FLR: 'FLR', // Failure - 실패
  UNK: 'UNK', // Unknown - 알수없음
  CNL: 'CNL'  // Cancelled - 취소됨
});

/** i18n 미적용·미번역 시 폴백 (한국어 기본) */
const STATUS_TEXT_MAP = Object.freeze({
  [PROGRESS_STATUS.BEF]: '분석전',
  [PROGRESS_STATUS.ING]: '분석중',
  [PROGRESS_STATUS.FIN]: '분석완료',
  [PROGRESS_STATUS.FLR]: '실패',
  [PROGRESS_STATUS.UNK]: '알 수 없음',
  [PROGRESS_STATUS.CNL]: '취소됨'
});

/**
 * 상태별 색상 매핑
 */
const STATUS_COLOR_MAP = Object.freeze({
  [PROGRESS_STATUS.BEF]: 'secondary',
  [PROGRESS_STATUS.ING]: 'blue',
  [PROGRESS_STATUS.FIN]: 'green',
  [PROGRESS_STATUS.FLR]: 'red',
  [PROGRESS_STATUS.CNL]: 'orange',
  [PROGRESS_STATUS.UNK]: 'secondary'
});

/**
 * 진행 상태를 현재 locale 기준 표시 문자열로 변환
 * @param {string} status - 진행 상태 코드 (BEF, ING, FIN, FLR, UNK, CNL)
 * @returns {string}
 */
export function getStatusText(status) {
  if (!status) {
    return status;
  }
  const code = String(status).toUpperCase();
  const i18nKey = `progressStatus.${code}`;
  if (i18n && typeof i18n.te === 'function' && i18n.te(i18nKey)) {
    return String(i18n.t(i18nKey));
  }
  return STATUS_TEXT_MAP[code] || status;
}

/**
 * 진행 상태에 따른 색상 반환
 * @param {string} status - 진행 상태 코드 (BEF, ING, FIN, FLR, UNK, CNL)
 * @returns {string} Vuetify 색상 이름
 * 
 * @example
 * getStatusColor('BEF'); // 'secondary'
 * getStatusColor('ING'); // 'blue'
 */
export function getStatusColor(status) {
  if (!status) {
    return 'secondary';
  }
  const code = String(status).toUpperCase();
  return STATUS_COLOR_MAP[code] || 'secondary';
}

/**
 * 진행 상태를 문자열로 변환 (하위 호환성을 위한 함수)
 * @param {string} status - 진행 상태 코드
 * @returns {string}
 * @deprecated getStatusText를 사용하세요
 */
export function processStatusToString(status) {
  return getStatusText(status);
}

